import * as HydraNavState from '@customerio/hydra-nav-state';
import * as HydraPlumaState from '@customerio/hydra-pluma-state';
import { isHydraRoute } from '@/services/router/generate-path';
import * as HydraSessionState from '@customerio/hydra-session-state';

export default function injectGlobals() {
  Object.assign(window, {
    HydraNavState,
    HydraPlumaState,
    HydraSessionState,
    // Expose routing utilities for Ember to check if a URL belongs to Hydra
    __hydra__: {
      ...window.__hydra__,
      isHydraRoute,
    },
  });
}
